import Api from './api';

const ContasEducacaoService = {
    cadastroReceita: async (params) => {
        const response = await Api.post('/restrito/receitaeducacao/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarReceita: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/receitaeducacao/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarReceita: (id) => {
        Api.delete(`/restrito/receitaeducacao/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    receitaEdit: async (id) => {
        const response = await Api.get(`/restrito/receitaeducacao/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarReceita: async (id, params) => {
        const response = await Api.put(`/restrito/receitaeducacao/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarReceita: (params) => {
        const response = Api.get(`/restrito/receitaeducacao/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    cadastroDespesa: async (params) => {
        const response = await Api.post('/restrito/despesaeducacao/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listarDespesa: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/despesaeducacao/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletarDespesa: (id) => {
        Api.delete(`/restrito/despesaeducacao/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    despesaEdit: async (id) => {
        const response = await Api.get(`/restrito/despesaeducacao/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editarDespesa: async (id, params) => {
        const response = await Api.put(`/restrito/despesaeducacao/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscarDespesa: (params) => {
        const response = Api.get(`/restrito/despesaeducacao/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default ContasEducacaoService;